// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"Simulator_simulatorContainer__3nqlV","mainTitle":"Simulator_mainTitle__2VvZM"};